const ACTION_PATH = 'app/servico'

export const CALL_COPIAR_DADOS = `${ACTION_PATH}/CALL_COPIAR_DADOS`

export const callCopiarDados = (payload) => ({
  type: CALL_COPIAR_DADOS,
  payload,
})
